export default __webpack_public_path__ + "static/media/loaderGif.bbbbf2a2.gif";